// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import {
    Autocomplete,
    Divider,
    IconButton,
    Tooltip,
} from '@mui/material'
import axios from 'axios'

import Icon from '../../../components/icon';
import apiUrl from '../../../configs/constant';
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';

import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import { useToast } from '../../../components/ToastProvider'
import Swal from "sweetalert2";
import moment from 'moment'
import DialogEditHargaJasa from '../../../components/production/DialogEditHargaJasa';
import DialogPencairanJasa from '../../../components/production/DialogPencairanJasa'

export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { showToast, hideToast } = useToast();

    // ** State
    const [openDialog, setOpenDialog] = useState<boolean>(false)
    const [listData, setListData] = useState<any[]>([])

    const [tglAwal, setTglAwal] = useState<string>(moment().subtract(3, 'months').startOf('month').format('YYYY-MM-DD'))
    const [tglAkhir, setTglAkhir] = useState<string>(moment().endOf('month').format('YYYY-MM-DD'))

    useEffect(() => {
        getData()
    }, [])

    const getData = () => {
        setListData([])
        let url = apiUrl.apiUrl + '/production/jasa-work-order/outstanding-wo'

        axios
            .get(url, {
                params: {
                    awal: tglAwal,
                    akhir: tglAkhir
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const approveWorkOrder = (row: any, mode: any) => {
        const payload = {
            wo_order_id: row.id,
            mode: mode
        };

        const url = apiUrl.apiUrl + '/production/jasa-work-order/approve-wo'
        axios.post(url, payload, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then(response => {
                if (response.data.success) {
                    getData()
                    showToast(response.data.message, "success")
                } else {
                    showToast(response.data.message, "error")
                }
            })
            .catch(error => {
                showToast(error.message, "error")
            })
    };

    const convertComponent = [
        {
            key: 'cek_jahit',
            renderCell: ({ row }: any) => (
                <>
                    {row.data.cek_jahit == 0 ? (
                        <Button
                            variant="contained"
                            color="success"
                            startIcon={<Icon icon="mdi:check-circle" />}
                            onClick={() => approveWorkOrder(row.data, 'JAHIT')}
                        >
                            APPROVE
                        </Button>
                    ) : (<Icon icon="mdi:check-circle" />)}
                </>
            )
        },
        {
            key: 'cek_potong',
            renderCell: ({ row }: any) => (
                <>
                    {row.data.cek_potong == 0 ? (
                        <Button
                            variant="contained"
                            color="success"
                            startIcon={<Icon icon="mdi:check-circle" />}
                            onClick={() => approveWorkOrder(row.data, 'POTONG')}
                        >
                            APPROVE
                        </Button>
                    ) : (<Icon icon="mdi:check-circle" />)}
                </>
            )
        },
        {
            key: 'cek_bordir',
            renderCell: ({ row }: any) => (
                <>
                    {row.data.cek_bordir == 0 ? (
                        <Button
                            variant="contained"
                            color="success"
                            startIcon={<Icon icon="mdi:check-circle" />}
                            onClick={() => approveWorkOrder(row.data, 'BORDIR')}
                        >
                            APPROVE
                        </Button>
                    ) : (<Icon icon="mdi:check-circle" />)}
                </>
            )
        },
        {
            key: 'link',
            minWidth: 200,
            renderCell: ({ row }: any) => {
                const url = row.data?.link;

                if (!url) {
                    return <span style={{ color: "#999" }}>Tidak ada gambar</span>;
                }

                const openImage = () => {
                    Swal.fire({
                        title: 'Preview Gambar',
                        imageUrl: url,
                        imageWidth: 200,     // atur ukuran gambar
                        imageHeight: 'auto',
                        imageAlt: 'Preview',
                        showCloseButton: true,
                        showConfirmButton: false,
                        background: '#f9f9f9',
                        didClose: () => {
                            setOpenDialog(true);
                        }
                    });
                };

                return (
                    <img
                        src={url}
                        alt="Preview"
                        style={{
                            height: "120px",
                            width: "auto",
                            objectFit: "contain",
                            borderRadius: "8px",
                            cursor: "pointer",
                        }}
                        onClick={(e: React.MouseEvent<HTMLImageElement>) => {
                            e.stopPropagation(); // cegah rowClick
                            setOpenDialog(false);
                            openImage()
                        }}
                    />
                );
            }
        }
    ]

    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title='APPROVAL WORK ORDER' />
                        </Box>
                    </Box>
                    <Divider />
                    <CardContent>
                        <Grid
                            container
                            spacing={3}
                            alignItems="flex-end"
                        >
                            <Grid item xs={12} md={3}>
                                <TextField
                                    fullWidth
                                    label="Tanggal Awal"
                                    type="date"
                                    value={tglAwal}
                                    onChange={(e) => setTglAwal(e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>

                            <Grid item xs={12} md={3}>
                                <TextField
                                    fullWidth
                                    label="Tanggal Akhir"
                                    type="date"
                                    value={tglAkhir}
                                    onChange={(e) => setTglAkhir(e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>

                            <Grid item xs={12} md={2}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    startIcon={<Icon icon="mdi:magnify" />}
                                    onClick={() => getData()}
                                    sx={{ height: 56 }}
                                >
                                    Cari Data
                                </Button>
                            </Grid>
                        </Grid>
                    </CardContent>
                    <MsiDatagrid array={listData} customRender={convertComponent} />
                </div>
            </Grid>
        </Grid>
    )
}
